var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.modules && !!_vm.modules['invoices'])?_c('router-link',{staticClass:"btn btn-link ml-auto",attrs:{"to":"/app/bookings/invoices/wizards"}},[_c('fa-icon',{attrs:{"icon":"magic"}}),_vm._v(" Invoices Wizards ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }